import { Box, Stack, VStack } from "@chakra-ui/react";
import React from "react";
import { useFormikContext } from "formik";
import { CherryPayApi } from "../../api/models";
import { InfoPanel } from "../Utilities/InfoPanel";
import { NotificationPreviewType } from "../ImagePreview/ImagePreview";
import { FormDevicePreviewPanel } from "./FormDevicePreviewPanel";
import { FormNotificationSummary } from "./FormNotificationSummary";
import { useBusinessContext } from "../../context/ModelContext";
import { NotificationFormValues } from "../../forms/Notifications/types";
import { isEmptyStr } from "../../util/StringUtil";

interface NotificationPreviewProps {
  notification: CherryPayApi.CherryPassNotificationScheduleDetail;
  memberCount?: number | null;
  geoLocations: CherryPayApi.GeoLocation[];
  selectedGeoLocationId: string | null;
  notificationType: NotificationPreviewType;
  onNotificationTypeChange: (value: NotificationPreviewType) => void;
}

export const NotificationPreview: React.FC<NotificationPreviewProps> = ({
  notification,
  memberCount,
  geoLocations,
  selectedGeoLocationId,
  notificationType,
  onNotificationTypeChange,
}) => {
  const businessSummary = useBusinessContext();
  const { values } = useFormikContext<NotificationFormValues>();

  const hasGeoLocations = geoLocations.length > 0;
  const selectedLocation =
    geoLocations.find((l) => l.GeoLocationId === selectedGeoLocationId) ?? null;
  const selectedOverride = selectedLocation?.Meta?.Id
    ? values.locationMessageOverrides?.[selectedLocation.Meta.Id]
    : undefined;
  const isOverridden = !isEmptyStr(selectedOverride);
  const selectedLocationName = selectedLocation?.DisplayName || null;

  const rawNotificationMessage = notification.PassUpdateMessage ?? "";
  const locationMessage = selectedLocation
    ? isOverridden
      ? selectedOverride!
      : selectedLocation.RelevantText ?? ""
    : "";

  const isGeoMode = hasGeoLocations && notificationType === "geo";
  const isGoogleTabDisabled = isGeoMode;

  let lockScreenMessage: string;
  let backOfPassMessage: string | null;

  if (isGeoMode) {
    lockScreenMessage = locationMessage;
    backOfPassMessage = null;
  } else {
    lockScreenMessage = rawNotificationMessage;
    backOfPassMessage = rawNotificationMessage;
  }

  return (
    <Box w="100%" p={4}>
      <Stack spacing={6} w="100%">
        <InfoPanel>
          The business logo shown on the push notification and the pass design
          on the back of the pass are for <b>example purposes only</b>. Your
          actual business logo and pass design will be applied when published.{" "}
        </InfoPanel>

        <VStack align="stretch" w="100%" spacing={4}>
          <FormDevicePreviewPanel
            businessDisplayName={businessSummary.DisplayName}
            lockScreenMessage={lockScreenMessage}
            backOfPassMessage={backOfPassMessage}
            isGoogleTabDisabled={isGoogleTabDisabled}
            notificationType={notificationType}
            onNotificationTypeChange={onNotificationTypeChange}
            showNotificationTypeToggle={hasGeoLocations}
            selectedLocationName={selectedLocationName}
          />
          <FormNotificationSummary
            notification={notification}
            memberCount={memberCount}
            businessId={businessSummary.BusinessId}
            geoLocations={geoLocations}
            locationMessageOverrides={values.locationMessageOverrides ?? {}}
          />
        </VStack>
      </Stack>
    </Box>
  );
};
